import { useState } from "react";
import { Button } from "react-bootstrap";
import ausloggen from "./img/ausloggen.png";

export default function FehlerMeldung({ errorMessage, setErrorMessage }) {
   return (
      <div className="error-message">
         <h3>Fehler</h3>
         {errorMessage.error && errorMessage.error === "sharepoint" && (
            <>
               <div dangerouslySetInnerHTML={{ __html: errorMessage.message }} />

               <div>
                  <img className="m-3 mt-5" src={ausloggen} />
                  <p>Wenn der Fehler weiterhin besteht, bitte einmal oben links ausloggen und wieder einloggen.</p>
                  <p>Wenn der Fehler weiterhin besteht, Nachricht an JM.</p>
               </div>
            </>
         )}

         {errorMessage.error && errorMessage.error === "onOffice" && (
            <>
               Bitte den Text unten kopieren und als{" "}
               <a href="https://teams.microsoft.com/l/chat/0/0?users=j.mischke@baurimmo.onmicrosoft.com">
                  Teams Nachricht an Jonathan Mischke (hier klicken)
               </a>{" "}
               Möglicherweise hilft es auch schon die Seite neu zu laden.
               <div
                  style={{ boxShadow: "0 0 10px #aaa", borderRadius: "10px" }}
                  className="m-4 p-3"
                  dangerouslySetInnerHTML={{ __html: errorMessage.message }}
               />
            </>
         )}
         <Button variant="danger" className="mt-4" onClick={() => setErrorMessage("")}>
            Fehlermeldung ausblenden
         </Button>
      </div>
   );
}
